const general = {
    general: {
        menu: {
            statistics: 'Statistics',
            stats: 'Stats',
            practice: 'My Practice',
            sessions: 'Practices',
            users: 'Members',
            goals: 'Goals',
            managers: 'Managers',
            businesses: 'Businesses',
            settings: 'Settings',
            logout: 'Log out',
            programs: 'Programs',
            coupons: 'Coupons',
            reminders: 'Reminders',
            timer: 'Timer',
            pages: 'Pages',
            feed: 'New',
            reports: 'Reports'
        },
        hello: 'Hello, <strong>{user}</strong>',
        back: 'Back',
        close: 'Close',
        edit: 'Edit',
        remove: 'Remove',
        footer: {
            topText: 'Chill Anywhere ',
            bottomText: '©2023 Chill Chicago. All Rights Reserved.',
            email: 'chillapp@chillchicago.com',
            links: {
                termsAndConditions: 'Terms & Conditions',
                privacy: 'Privacy'
            }
        },
        iAccept: 'I Accept',
        ok: 'OK',
        skip: 'Skip',
        // Please use ISO 639-1 for the codes
        languages: {
            es: 'Spanish',
            en: 'English',
            ua: 'Ukrainian',
            de: 'German'
        }
    }
};

export default general;
